import { render, staticRenderFns } from "./DiagArchiModal.vue?vue&type=template&id=4cfde23f&scoped=true&"
import script from "./DiagArchiModal.vue?vue&type=script&lang=js&"
export * from "./DiagArchiModal.vue?vue&type=script&lang=js&"
import style0 from "./DiagArchiModal.vue?vue&type=style&index=0&id=4cfde23f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfde23f",
  null
  
)

export default component.exports